module.exports = __webpack_public_path__ + "img/vertical&rtl.675e88dd.jpg";